<template>
  <a-layout-header :class="[headerTheme, 'admin-header', noshadown]">
    <div
      :class="['admin-header-wide', layout, pageWidth]"
      style="display: flex"
    >
      <router-link
        v-if="isMobile || layout === 'head'"
        to="/"
        :class="['logo', isMobile ? null : 'pc', headerTheme]"
      >
        <svg-icon iconClass="logo" class="logosvg"></svg-icon>
        <!-- <img width="32" src="@/assets/img/logo.png" /> -->
        <!-- <h1 v-if="!isMobile">{{ systemName }}</h1> -->
      </router-link>
      <!-- <a-divider v-if="isMobile" type="vertical" /> -->
      <!-- <a-icon
        v-if="layout !== 'head'"
        class="trigger"
        :type="collapsed ? 'menu-unfold' : 'menu-fold'"
        @click="toggleCollapse"
      /> -->
      <div class="admin-header-left-wrapper">
        <div
          class="quota-warning-scroll"
          v-if="quotaWarningList.length > 0"
          @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave"
        >
          <div
            class="quota-warning-list"
            :class="{ 'no-transition': !isTransitioning }"
            :style="{ transform: `translateY(-${translateY}px)` }"
            @transitionend="handleTransitionEnd"
          >
            <!-- 最后一个项目的克隆（用于无缝循环） -->
            <div
              class="quota-warning-item"
              v-if="quotaWarningList.length > 1"
              :key="'clone-last'"
            >
              <span class="quota-label">{{ $t("QuotaWarning") }}:</span>
              <span class="quota-text"
                >{{ $t("LinkedinAccout") }}:
                {{
                  quotaWarningList[quotaWarningList.length - 1].linkedin_email
                }}</span
              >
              <span class="quota-text">|</span>
              <span class="quota-text">{{
                quotaWarningList[quotaWarningList.length - 1].version_name
              }}</span>
              <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    quotaWarningList[quotaWarningList.length - 1].entitlement.connection_request_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement.max_connection_request
                  ),
                  'quota-text': !isRed(
                    quotaWarningList[quotaWarningList.length - 1].entitlement.connection_request_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement.max_connection_request
                  ),
                }"
                >{{ $t("ConnectionRequestQuota") }}：
                <b>
                  {{ quotaWarningList[0].entitlement.connection_request_balance }}
                </b>
              </span>
              <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .connection_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .max_connection
                  ),
                  'quota-text': !isRed(
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .connection_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .max_connection
                  ),
                }"
                >{{ $t("ConnectionMadeQuota") }}:
                <b>
                  {{
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .connection_balance
                  }}
                </b>
              </span>
              <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .message_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .max_message
                  ),
                  'quota-text': !isRed(
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .message_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .max_message
                  ),
                }"
                >{{ $t("MessageQuota") }}:
                <b>
                  {{
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .message_balance
                  }}
                </b>
              </span>
              <template
                v-if="
                  (
                  (
                      quotaWarningList[quotaWarningList.length - 1].entitlement.connection_request_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement.max_connection_request
                  )||
                  isRed(
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .message_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .max_message
                  ) ||
                  isRed(
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .connection_balance,
                    quotaWarningList[quotaWarningList.length - 1].entitlement
                      .max_connection
                  )) && quotaWarningList[quotaWarningList.length - 1].version_name != 'Prime Plan'
                "
              >
                <span class="quota-text">|</span>
                <span class="quota-text">{{ $t("Upgradeplan") }}:</span>
                // eslint-disable-next-line no-irregular-whitespace,
                no-irregular-whitespace
                <a :href="'mailto:' + mailInfo" class="quota-link">{{
                  mailInfo
                }}</a>
              </template>
            </div>
            <!-- 真实数据列表 -->
            <div
              class="quota-warning-item"
              v-for="(item, index) in quotaWarningList"
              :key="index"
            >
              <span class="quota-label">{{ $t("QuotaWarning") }}:</span>
              <span class="quota-text"
                >{{ $t("LinkedinAccout") }}: {{ item.linkedin_email }}</span
              >
              <span class="quota-text">|</span>
              <span class="quota-text">{{ item.version_name }}</span>
              <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    item.entitlement.connection_request_balance,
                   item.entitlement.max_connection_request
                  ),
                  'quota-text': !isRed(
                    item.entitlement.connection_request_balance,
                    item.entitlement.max_connection_request
                  ),
                }"
                >{{ $t("ConnectionRequestQuota") }}：
                <b>
                  {{item.entitlement.connection_request_balance }}
                </b>
              </span>
              <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    item.entitlement.connection_balance,
                    item.entitlement.max_connection
                  ),
                  'quota-text': !isRed(
                    item.entitlement.connection_balance,
                    item.entitlement.max_connection
                  ),
                }"
                >{{ $t("ConnectionMadeQuota") }}:
                <b>
                  {{ item.entitlement.connection_balance }}
                </b>
              </span>
              <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    item.entitlement.message_balance,
                    item.entitlement.max_message
                  ),
                  'quota-text': !isRed(
                    item.entitlement.message_balance,
                    item.entitlement.max_message
                  ),
                }"
                >{{ $t("MessageQuota") }}:
                <b>
                  {{ item.entitlement.message_balance }}
                </b>
              </span>
              <template
                v-if="
                  ((
                      item.entitlement.connection_request_balance,
                    item.entitlement.max_connection_request
                  )||
                  isRed(
                    item.entitlement.message_balance,
                    item.entitlement.max_message
                  ) ||
                  isRed(
                    item.entitlement.connection_balance,
                    item.entitlement.max_connection
                  ))&& item.version_name != 'Prime Plan'
                "
              >
                <span class="quota-text">|</span>
                <span class="quota-text">{{ $t("Upgradeplan") }}:</span>
                <a :href="'mailto:' + mailInfo" class="quota-link">{{
                  mailInfo
                }}</a>
              </template>
            </div>
            <!-- 第一个项目的克隆（用于无缝循环） -->
            <div
              class="quota-warning-item"
              v-if="quotaWarningList.length > 1"
              :key="'clone-first'"
            >
              <span class="quota-label">{{ $t("QuotaWarning") }}:</span>
              <span class="quota-text"
                >{{ $t("LinkedinAccout") }}:
                {{ quotaWarningList[0].linkedin_email }}</span
              >
              <span class="quota-text">|</span>
              <span class="quota-text">{{
                quotaWarningList[0].version_name
              }}</span>
               <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    quotaWarningList[0].entitlement.connection_request_balance,
                    quotaWarningList[0].entitlement.max_connection_request
                  ),
                  'quota-text': !isRed(
                    quotaWarningList[0].entitlement.connection_request_balance,
                    quotaWarningList[0].entitlement.max_connection_request
                  ),
                }"
                >{{ $t("ConnectionRequestQuota") }}：
                <b>
                  {{ quotaWarningList[0].entitlement.connection_request_balance }}
                </b>
              </span>
              <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    quotaWarningList[0].entitlement.connection_balance,
                    quotaWarningList[0].entitlement.max_connection
                  ),
                  'quota-text': !isRed(
                    quotaWarningList[0].entitlement.connection_balance,
                    quotaWarningList[0].entitlement.max_connection
                  ),
                }"
                >{{ $t("ConnectionMadeQuota") }}:
                <b>
                  {{ quotaWarningList[0].entitlement.connection_balance }}
                </b>
              </span>
              <span class="quota-text">|</span>
              <span
                :class="{
                  'quota-label-red': isRed(
                    quotaWarningList[0].entitlement.message_balance,
                    quotaWarningList[0].entitlement.max_message
                  ),
                  'quota-text': !isRed(
                    quotaWarningList[0].entitlement.message_balance,
                    quotaWarningList[0].entitlement.max_message
                  ),
                }"
                >{{ $t("MessageQuota") }}:
                <b>
                  {{ quotaWarningList[0].entitlement.message_balance }}
                </b>
              </span>
              <template
                v-if="
                 (
                 isRed(
                    quotaWarningList[0].entitlement.connection_request_balance,
                    quotaWarningList[0].entitlement.max_connection_request
                  )||
                 isRed(
                    quotaWarningList[0].entitlement.message_balance,
                    quotaWarningList[0].entitlement.max_message
                  ) ||
                  isRed(
                    quotaWarningList[0].entitlement.connection_balance,
                    quotaWarningList[0].entitlement.max_connection
                  )) &&  quotaWarningList[0].version_name != 'Prime Plan'
                "
              >
                <span class="quota-text">|</span>
                <span class="quota-text">{{ $t("Upgradeplan") }}:</span>
                <a :href="'mailto:' + mailInfo" class="quota-link">{{
                  mailInfo
                }}</a>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- <div>
        <div
          class="freeTips"
          v-if="showToolbar && !haveAccount"
          @click="skipPay"
          style="cursor: pointer; display: none"
        >
          <a-icon
            type="exclamation-circle"
            style="font-size: 12px; color: #ffa200; margin-right: 5px"
          />
          <span :class="[lang]">{{
            $t("freeTrail").replace("**", havedays)
          }}</span>
          <a-icon
            type="right"
            style="font-size: 12px; color: #ffa200; margin-left: 5px"
          />
        </div>
        <div
          class="freeTips"
          v-if="showToolbar && haveAccount"
          style="cursor: pointer; display: none"
        >
          <a-icon
            type="exclamation-circle"
            style="font-size: 12px; color: #ffa200; margin-right: 5px"
          />
          <span :class="[lang]" v-html="haveAccountTips"></span>
          <span class="goUpgrade" @click="skipPay">{{ $t("UpgradeNow") }}</span>
        </div>
      </div> -->

      <div
        v-if="layout !== 'side' && !isMobile"
        class="admin-header-menu"
        :style="`width: ${menuWidth};`"
      >
        <i-menu
          class="head-menu"
          :class="[lang]"
          :theme="headerTheme"
          mode="horizontal"
          :options="menuData"
          @select="onSelect"
        />
      </div>
      <div class="admin-header-right-wrapper">
        <div :class="['admin-header-right', headerTheme]">
          <!-- <header-search
          class="header-item"
          @active="(val) => (searchActive = val)"
        /> -->
          <!-- <a-tooltip class="header-item" title="帮助文档" placement="bottom" >
            <a href="https://iczer.gitee.io/vue-antd-admin-docs/" target="_blank">
              <a-icon type="question-circle-o" />
            </a>
          </a-tooltip> -->
          <!-- <header-notice class="header-item" /> -->
          <!-- <div class="">
          <a-button type="primary" size="large">{{ $t("price") }}</a-button>
        </div> -->
          <a-dropdown class="lang header-item">
            <div><a-icon type="global" /> {{ langAlias }}</div>
            <a-menu
              @click="(val) => setClang(val)"
              :selected-keys="[localLang ? localLang : lang]"
              slot="overlay"
            >
              <a-menu-item v-for="lang in langList" :key="lang.key">{{
                lang.name
              }}</a-menu-item>
            </a-menu>
          </a-dropdown>
          <header-avatar class="header-item" />
        </div>
        <!-- 激活码兑换下拉框 -->
        <div class="admin-header-right redeemCodeDropdown">
          <a-popover
            title=""
            overlayClassName="redeemCode-popover"
            v-model="visible"
            trigger="click"
          >
            <template slot="content">
              <div class="popover-title" :class="[lang]">
                {{ $t("RedeemCodeDropdownTitle") }}
                <a-popover
                  style="z-index: 98"
                  trigger="click"
                  v-model="helpVisiable"
                  placement="leftTop"
                >
                  <template slot="content">
                    <div
                      class="popbox"
                      :style="{
                        'text-align': lang == 'AR' ? 'right' : 'left',
                      }"
                    >
                      <p class="main-tit" :class="[lang]">
                        {{ $t("helpTitle") }}
                      </p>
                      <div class="ptit" :class="[lang]">
                        {{ $t("helpDes") }}
                      </div>

                      <p class="main-tit" :class="[lang]">
                        {{ $t("helpTitle2") }}
                      </p>
                      <div class="ptit" :class="[lang]">
                        {{ $t("helpDes2") }}
                      </div>

                      <p class="main-tit" :class="[lang]">
                        {{ $t("helpTitle3") }}
                      </p>
                      <div class="ptit" :class="[lang]">
                        <div>{{ $t("helpDes3") }}</div>
                        <div>{{ $t("helpDes4") }}</div>
                        <div>{{ $t("helpDes5") }}</div>
                        <div>{{ $t("helpDes6") }}</div>
                        <div>{{ $t("helpDes7") }}</div>
                        <div>{{ $t("helpDes8") }}</div>
                        <div>{{ $t("helpDes9") }}</div>
                      </div>

                      <p class="main-tit" :class="[lang]">
                        {{ $t("helpTitle3") }}
                      </p>
                      <div class="ptit" :class="[lang]">
                        {{ $t("helpDes10") }}
                      </div>
                    </div>
                  </template>

                  <a-icon
                    type="question-circle"
                    style="
                      font-size: 14px;
                      color: #0e756a;
                      cursor: pointer;
                      margin-left: 6px;
                    "
                  />
                </a-popover>
              </div>
              <a-spin :spinning="codeListLoading">
                <div
                  class="code-con beauty-scroll"
                  :class="[lang]"
                  v-if="codeList && codeList.length"
                >
                  <div
                    class="code-item"
                    v-for="item in codeList"
                    :key="item.order_id"
                    :class="{
                      'code-disable':
                        item.linkedin_login != 0 && item.linkedin_email,
                    }"
                  >
                    <div class="num" :class="[lang]">{{ item.code }}</div>
                    <div class="code-txt" :class="[lang]">
                      {{ getCodeText(item) }}
                    </div>
                    <div
                      class="LinkedinAccount-txt ellipsis"
                      :class="[lang]"
                      v-if="item.linkedin_login != 0 && item.linkedin_email"
                    >
                      {{ $t("LinkedinAccount") }}
                      <span :title="item.linkedin_email">{{
                        item.linkedin_email
                      }}</span>
                    </div>
                    <div
                      class="link-account-btn"
                      :class="[lang]"
                      v-else
                      @click="goLinkedinAccount(item)"
                    >
                      {{ $t("LinkAccountBtn") }}
                    </div>
                  </div>
                </div>
                <div class="no-data" v-else :class="[lang]">
                  {{ $t("noData") }}
                </div>
              </a-spin>
              <div class="footer-btn" @click="showSetCodeModal" :class="[lang]">
                {{ $t("RedeemActivationCode") }}
              </div>
            </template>
            <div :class="[lang]" class="header-item" @click="showCodePopover">
              {{ $t("RedeemCode") }}
            </div>
          </a-popover>
        </div>
      </div>
    </div>
    <a-modal
      title=""
      :visible="showCodeDialog"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :closable="false"
      :maskClosable="false"
      :okText="$t('Confirm')"
      :cancelText="$t('Cancel')"
      dialogClass="showCodeTialog-class"
      v-if="showCodeDialog"
    >
      <div class="modal-title">{{ $t("RedeemActivationCode") }}</div>
      <a-form :form="form" class="form" layout="horizontal">
        <a-form-item
          style="margin-bottom: 10px; margin-top: 16px"
          :class="[lang]"
        >
          <a-input
            size="large"
            class="process-input"
            :maxLength="16"
            v-decorator="[
              'code',
              {
                initialValue: code,
                trim: true,
                rules: [
                  {
                    required: true,
                    validator: function (rule, value, callback) {
                      if (!value || !value.trim('')) {
                        callback($t('modalInputError'));
                        return;
                      }
                      callback();
                    },
                  },
                ],
              },
            ]"
            :placeholder="$t('modalInput')"
          >
          </a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-layout-header>
</template>

<script>
// import HeaderSearch from "./HeaderSearch";
// import HeaderNotice from "./HeaderNotice";
import HeaderAvatar from "./HeaderAvatar";
import IMenu from "@/components/menu/menu";
import { mapState, mapMutations } from "vuex";

export default {
  name: "AdminHeader",
  components: { IMenu, HeaderAvatar },
  props: ["collapsed", "menuData"],
  data() {
    return {
      freeTipsTimer: null,
      showToolbar: false,
      haveAccount: null,
      havedays: 0,
      mailInfo: "info@strategybrain.ca",
      langList: [
        { key: "CN", name: "简体中文", alias: "简体" },
        { key: "AR", name: "اللغة العربية", alias: "اللغة العربية" },
        // { key: "HK", name: "繁體中文", alias: "繁體" },
        { key: "US", name: "English", alias: "English" },
      ],
      searchActive: false,
      localLang: localStorage.getItem("lang"),
      visible: false,
      showCodeDialog: false,
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
      confirmLoading: false,
      code: "",
      codeList: [],
      codeListLoading: false,
      helpVisiable: false,
      quotaWarningList: [],
      currentIndex: 1, // 从1开始，因为第一个是克隆项
      translateY: 0,
      isTransitioning: true,
      quotaUpdateTimer: null,
      isResetting: false, // 标记是否正在重置位置
      isPaused: false, // 标记是否暂停滚动
      resetTimer: null, // 重置定时器
    };
  },
  i18n: require("./i18n"),
  computed: {
    ...mapState("setting", [
      "theme",
      "isMobile",
      "layout",
      "systemName",
      "lang",
      "pageWidth",
    ]),
    haveAccountTips() {
      return this.$t("accountFreeDays")
        .replace("**", `<span class='days'>${this.havedays}</span>`)
        .replace(
          "[]",
          `<span class='account ellipsis' title="${this.haveAccount}">${this.haveAccount}</span>`
        );
    },
    noshadown() {
      if (
        this.$route.fullPath.indexOf("/sales/salesReps/") > -1 ||
        this.$route.fullPath.indexOf("/setting/userSetting/") > -1 ||
        this.$route.fullPath.indexOf("/setting/order") > -1
      ) {
        return "noshadown";
      } else {
        return "";
      }
    },
    headerTheme() {
      // if (
      //   this.layout == "side" &&
      //   this.theme.mode == "dark" &&
      //   !this.isMobile
      // ) {
      //   return "light";
      // }
      // return this.theme.mode;
      return "light";
    },
    langAlias() {
      let lang = this.langList.find(
        (item) => item.key == (this.localLang ? this.localLang : this.lang)
      );
      return lang.alias;
    },
    menuWidth() {
      const { layout, searchActive } = this;
      const headWidth = layout === "head" ? "100% - 188px" : "100%";
      const extraWidth = searchActive ? "600px" : "400px";
      return `calc(${headWidth} - ${extraWidth})`;
    },
  },

  methods: {
    isRed(count, maxCount) {
      if(count =='Unlimited'){
        return false
      }
      else if (count / maxCount > 0.3) {
        return false;
      } else {
        return true;
      }
    },
    readMeHandler() {
      this.writeLog("redeem", "page_click", "redeem_code");
    },
    skipPay() {
      if (this.user.free_info.account) {
        this.$router.push({
          path: "/setting/userSetting/plan",
          query: {
            // 有账户时可以在付完费直接绑定
            upgrade_free: this.user.free_info.account ? 1 : 0,
            // campaign_type: 1,
            campaign_type: this.user.free_info.bind_type,
          },
        });
      } else {
        this.$router.push({
          path: "/setting/userSetting/plan",
          // query: {
          //   campaign_type: 1,
          // },
        });
      }
    },

    initFreeInfo() {
      //this.getTimes(new Date("2024-11-17 22:27:24"));
      // 1970-01-01T00:00:00Z
      // this.formatTimeZoneTime("2024-11-18 20:26:24");
      let free_info =
        this.user && this.user.free_info ? this.user.free_info : null;
      // console.log(free_info);
      if (free_info) {
        let { end_date, account } = free_info;
        // let start = new Date(start_date).getTime();
        let end = new Date(end_date).getTime();
        this.haveAccount = account;
        if (this.serverTime > end) {
          this.showToolbar = false;
        } else {
          this.showToolbar = true;
        }
      } else {
        this.showToolbar = false;
      }

      if (this.showToolbar) {
        let { end_date } = free_info;
        let end = new Date(end_date).getTime() - 3000;
        this.havedays = Math.ceil((end - Date.now()) / (24 * 60 * 60 * 1000));
      } else {
        this.havedays = 0;
      }
    },
    setClang(val) {
      this.localLang = val.key;
      localStorage.setItem("lang", val.key);
      this.setLang(val.key);
    },
    toggleCollapse() {
      this.$emit("toggleCollapse");
    },
    onSelect(obj) {
      this.$emit("menuSelect", obj);
    },
    ...mapMutations("setting", ["setLang"]),
    // 获取订单列表
    getCodeList() {
      this.codeListLoading = true;
      this.codeList = [];
      this.$axios("/payment/activation_code_list", {}, "post")
        .then((res) => {
          this.codeListLoading = false;
          if (res.code == "200") {
            this.codeList = res.data;
          }
        })
        .catch(() => {
          this.codeListLoading = false;
        });
    },
    getCodeText(item) {
      if (item.campaign_type == 1) {
        return this.$t("salesCodeTxt").replace(
          "X",
          item.subscription_plan_name || ""
        );
      } else if (item.campaign_type == 2) {
        return this.$t("recruiterCodeTxt").replace(
          "X",
          item.subscription_plan_name || ""
        );
      } else if (item.campaign_type == 3) {
        return this.$t("PrimeCode");
      }
    },
    // 进入订单绑定页，绑定
    goLinkedinAccount(record) {
      let params = {};
      if (record.linkedin_id) {
        params.linkedin_id = record.linkedin_id;
        if (record.timezone_config_id) {
          params.timezone_config_id = record.timezone_config_id;
        }
        if (record.country_config_id) {
          params.country_config_id = record.country_config_id;
        }
      }
      this.$router.push({
        path: "/setting/bindAccount",
        query: {
          id: record.order_id,
          campaign_type: record.campaign_type,
          ...params,
          backPath: "order",
        },
      });
      this.visible = false;
    },
    showSetCodeModal() {
      this.visible = false;
      setTimeout(() => {
        this.showCodeDialog = true;
        this.writeLog("redeem", "page_click", "activation_code");
      });
    },
    handleCancel() {
      this.showCodeDialog = false;
      this.writeLog("redeem", "page_click", "cancel");
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.writeLog("redeem", "page_click", "confirm");
          this.$axios(
            "/payment/activate_subscription",
            {
              activation_code: values.code,
            },
            "post"
          )
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(this.$t("codeSuccess"));
                if (res.data && !res.data.is_upgrade) {
                  this.$router.push({
                    path: "/setting/bindAccount",
                    query: {
                      id: res.data.new_order_id,
                      // campaign_type: res.data.campaign_type,
                      backPath: "order",
                    },
                  });
                } else {
                  window.location.reload();
                }
                this.handleCancel();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    showCodePopover() {
      this.visible = !this.visible;
      this.readMeHandler();
      this.getCodeList();
    },
    // 获取配额警告列表
    getQuotaWarningList() {
      // 这里应该调用实际的API获取数据

      const oldLength = this.quotaWarningList.length;
      //this.quotaWarningList = newList;

      // 如果数据长度变化，调整索引
      const itemHeight = 50; // 每个项目的高度（像素）
      if (oldLength === 0 && this.quotaWarningList.length > 0) {
        // 从1开始，因为第一个是克隆项
        this.currentIndex = this.quotaWarningList.length > 1 ? 1 : 0;
        this.translateY = this.currentIndex * itemHeight;
        this.isTransitioning = true;
      } else if (this.quotaWarningList.length > 1) {
        // 确保索引在有效范围内（1 到 length）
        if (this.currentIndex < 1) {
          this.currentIndex = 1;
        } else if (this.currentIndex > this.quotaWarningList.length) {
          this.currentIndex = this.quotaWarningList.length;
        }
        this.translateY = this.currentIndex * itemHeight;
        // 保持当前的过渡状态
      } else {
        this.currentIndex = 0;
        this.translateY = 0;
        this.isTransitioning = true;
      }
    },
    // 处理过渡结束事件
    handleTransitionEnd(event) {
      // 只处理 transform 属性的过渡结束
      if (event.propertyName !== "transform") {
        return;
      }

      // 如果当前在克隆的第一个项位置，需要重置到第一个真实项
      if (
        this.currentIndex > this.quotaWarningList.length &&
        !this.isResetting
      ) {
        this.isResetting = true;
        this.isTransitioning = false;
        const itemHeight = 50;
        this.currentIndex = 1;
        this.translateY = this.currentIndex * itemHeight;
        // 等待下一帧，确保跳转完成
        this.$nextTick(() => {
          this.isTransitioning = true;
          this.isResetting = false;
        });
      }
    },
    // 处理鼠标进入事件（暂停滚动）
    handleMouseEnter() {
      this.isPaused = true;
    },
    // 处理鼠标离开事件（恢复滚动）
    handleMouseLeave() {
      this.isPaused = false;
    },
    // 更新配额警告显示（滚动到下一个）
    updateQuotaWarning() {
      if (this.quotaWarningList.length <= 1) {
        return;
      }

      // 如果暂停滚动，跳过本次更新
      if (this.isPaused) {
        return;
      }

      // 如果正在重置位置，跳过本次更新
      if (this.isResetting) {
        return;
      }

      // 清除之前的重置定时器
      if (this.resetTimer) {
        clearTimeout(this.resetTimer);
        this.resetTimer = null;
      }

      const itemHeight = 50; // 每个项目的高度（像素）
      const transitionDuration = 600; // CSS transition 持续时间（毫秒）

      // 如果当前已经在最后一个克隆项位置，先无动画跳转到第一个真实项
      if (this.currentIndex > this.quotaWarningList.length) {
        this.isResetting = true;
        this.isTransitioning = false;
        this.currentIndex = 1;
        this.translateY = this.currentIndex * itemHeight;
        // 等待下一帧，确保跳转完成
        this.$nextTick(() => {
          this.isTransitioning = true;
          this.isResetting = false;
        });
        return;
      }

      // 如果当前是最后一个真实项，滚动到克隆的第一个项
      // 然后在动画进行到接近完成时提前重置，实现无缝循环
      if (this.currentIndex === this.quotaWarningList.length) {
        // 正常滚动到克隆的第一个项
        this.isTransitioning = true;
        this.currentIndex += 1;
        this.translateY = this.currentIndex * itemHeight;

        // 使用 requestAnimationFrame 来更精确地控制重置时机
        // 在动画进行到接近完成时（约590ms，总动画600ms）提前重置位置
        // 此时用户看到的是克隆的第一个项，重置到第一个真实项时内容相同，视觉上无缝
        let startTime = null;
        const resetTime = transitionDuration - 10; // 在动画完成前10ms重置

        const checkReset = (timestamp) => {
          if (!startTime) startTime = timestamp;
          const elapsed = timestamp - startTime;

          if (elapsed >= resetTime) {
            // 在重置前，先检查是否还在这个位置（防止被其他操作打断）
            if (
              this.currentIndex > this.quotaWarningList.length &&
              !this.isResetting
            ) {
              this.isResetting = true;
              this.isTransitioning = false;
              this.currentIndex = 1;
              this.translateY = this.currentIndex * itemHeight;
              // 重新启用过渡动画，为下一次滚动做准备
              this.$nextTick(() => {
                this.isTransitioning = true;
                this.isResetting = false;
              });
            }
          } else {
            requestAnimationFrame(checkReset);
          }
        };

        requestAnimationFrame(checkReset);
        return;
      }

      // 正常滚动到下一个
      this.isTransitioning = true;
      this.currentIndex += 1;
      this.translateY = this.currentIndex * itemHeight;
    },
    getLinkList() {
      this.$axios("/linkedin/list", {}, "post").then((res) => {
        if (res.code == 200) {
          let arr = [];
          res.data.forEach((item) => {
            // 去掉 这个条件判断item.version_name != "Prime Plan" &&
            if (
              item.entitlement.max_connection != 0 &&
              item.entitlement.max_message != 0
            ) {
              arr.push(item);
            }
          });
          this.quotaWarningList = arr;
          this.$nextTick(() => {
            if (this.quotaWarningList.length > 1) {
              const itemHeight = 50; // 每个项目的高度（像素）
              this.translateY = this.currentIndex * itemHeight;
            }
          });
        }
      });
    },
  },
  created() {
    // 初始化配额警告列表
    this.getLinkList();
    setInterval(() => {
      this.getLinkList();
    }, 1000 * 60 * 30);
  },
  mounted() {
    // 每6秒更新一次数据并滚动到下一个
    this.quotaUpdateTimer = setInterval(() => {
      // 如果暂停滚动，跳过本次更新
      if (this.isPaused) {
        return;
      }
      this.getQuotaWarningList();
      // 延迟一下再滚动，确保数据更新完成
      this.$nextTick(() => {
        // 只有在不是重置状态且未暂停时才更新
        if (!this.isResetting && !this.isPaused) {
          this.updateQuotaWarning();
        }
      });
    }, 6000);

    // 初始化时设置正确的 translateY

    this.getServiceTime().then((serverTime) => {
      let current = serverTime;
      current += 1000;
      this.freeTipsTimer = setInterval(() => {
        if (this.user && this.user.paid == 1) {
          this.showToolbar = false;
          return;
        }
        let free_info =
          this.user && this.user.free_info ? this.user.free_info : null;
        // console.log(free_info);
        if (free_info) {
          let { end_date, account } = free_info;
          // let start = new Date(start_date).getTime();
          let end = new Date(end_date).getTime();
          this.haveAccount = account;
          if (current > end) {
            this.showToolbar = false;
          } else {
            this.showToolbar = true;
          }
        } else {
          this.showToolbar = false;
        }

        if (this.showToolbar) {
          let { end_date } = free_info;
          let end = new Date(end_date).getTime() - 3000;
          this.havedays = Math.ceil((end - Date.now()) / (24 * 60 * 60 * 1000));
        } else {
          this.havedays = 0;
        }
      }, 1000);
    });
  },
  destroyed() {
    if (this.freeTipsTimer) {
      clearInterval(this.freeTipsTimer);
      this.freeTipsTimer = null;
    }
    if (this.quotaUpdateTimer) {
      clearInterval(this.quotaUpdateTimer);
      this.quotaUpdateTimer = null;
    }
    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
      this.resetTimer = null;
    }
  },
};
</script>

<style lang="less" scoped>
@import "index";
.admin-header-left-wrapper {
  width: 1px;
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 0 16px;
}

.quota-warning-scroll {
  width: 100%;
  height: 50px;
  overflow: hidden;
  position: relative;
  // 确保内容不会被裁剪
  clip-path: inset(0);
  // 使用 GPU 加速
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.quota-warning-list {
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  position: relative;
  // 确保列表容器有足够的高度来包含所有项目
  min-height:50px;
  // 使用 GPU 加速，提高性能和平滑度
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  perspective: 1000px;
  -webkit-perspective: 1000px;

  &.no-transition {
    transition: none !important;
  }
}

.quota-warning-item {
  height: 50px;
  min-height: 50px;
  
  font-size: 12px;
  display: flex;
  align-items: center;
  // 确保项目不会被压缩
  flex-shrink: 0;
  // 确保项目在容器内正确显示
  position: relative;
  width: 100%;
  flex-wrap: wrap;
  line-height: normal;

  > * {
    margin-right: 4px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.quota-label {
  color: #000;
  font-weight: 500;
}

.quota-text {
  color: #000;
}

.quota-label-red {
  color: #ff4d4f;
  font-weight: 500;
}

.quota-link {
  color: #1890ff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.dmin-header-right-wrapper {
  width: 320px;
}
.noshadown {
  box-shadow: none !important;
}
.admin-header {
  z-index: 100;
}
.freeTips {
  position: absolute;
  padding-right: 16px;
  height: 44px;
  padding-left: 14px;
  line-height: 44px;
  background: #fcf1df;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #ffbb00;
  font-size: 18px;
  color: #302525;
  // color: red;
  left: 19px;
  top: 10px;
  display: flex;
  align-items: center;
}

/deep/.days {
  text-decoration: none;
  font-weight: bold;
  color: #0e756a;
}
/deep/.account {
  display: inline-block;
  margin: 0 5px;
  color: #0e756a;
  font-weight: bold;
  color: #0e756a;
  max-width: 150px;
  vertical-align: middle;
}
.goUpgrade {
  // width: 67px;
  height: 29px;
  background: linear-gradient(180deg, #ffac00 0%, #f85760 100%);
  border-radius: 15px 15px 15px 15px;
  display: inline-block;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  line-height: 29px;
  text-align: center;
  cursor: pointer;
  padding: 0 12px;
  margin-left: 20px;
}
.redeemCodeDropdown {
  /deep/.header-item {
    color: #0e756a !important;
    font-weight: 500;
  }
}
.popbox {
  width: 480px;
  .main-tit {
    font-weight: bold;
    font-size: 16px;
    color: #0e756a;
    margin-bottom: 0;
    margin-top: 17px;
  }
  .ptit {
    margin-top: 17px;
    font-size: 14px;
    color: #000000;
    user-select: none;
    .rtl {
      margin-right: 0px;
      margin-left: 7px;
    }
    .txt-red {
      color: #ff4d4f;
    }
  }
}
</style>
<style lang="less">
.redeemCode-popover {
  padding-top: 0 !important;
  min-width: 340px;
  text-align: unset;
  // width: 340px;
  .ant-popover-inner-content {
    padding: 10px 0 0;
    .popover-title {
      font-weight: bold;
      margin-bottom: 12px;
      color: #000;
      font-size: 16px;
      padding: 0 12px;
    }
    .code-con {
      max-height: 500px;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 12px;
      .code-item {
        background: #f4f5f8;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          background: #eef8f7;
        }
        .num {
          color: #926752;
          font-weight: 600;
          font-size: 18px;
          line-height: 32px;
        }
        .code-txt {
          font-size: 14px;
          line-height: 24px;
        }
        .link-account-btn {
          cursor: pointer;
          color: #0e756a;
          font-weight: bold;
          font-size: 12px;
          display: inline-block;
        }
        &.code-disable {
          background: #f0f0f0;
          cursor: not-allowed;
          .num {
            color: rgba(0, 0, 0, 0.8);
          }
        }
      }
    }
    .no-data {
      text-align: center;
      line-height: 80px;
    }
    .footer-btn {
      color: #0e756a;
      padding: 10px 0;
      font-weight: bold;
      text-align: center;
      cursor: pointer;
    }
  }
  .ant-popover-arrow {
    display: none;
  }
}
.ant-modal.showCodeTialog-class {
  // top: 50%;
  // transform: translateY(-50%);
  .ant-modal-footer {
    border: none;
    display: flex;
    justify-content: center;
    & button + button {
      margin-left: 40px;
    }
  }
  .ant-modal-body {
    padding-bottom: 0;
  }
  .modal-title {
    font-size: 18px;
    font-weight: 500;
    color: #000;
    text-align: center;
  }
}
</style>
